export const GET_POKEMONS = "GET_POKEMONS";
export const SET_CURRENT_PAGE = "SET_CURRENT_PAGE";
export const GET_POKEMON_DETAILS = "GET_POKEMON_DETAILS";
export const LOADING = "LOADING";
export const LOADED = "LOADED";
export const SET_LIMIT = "SET_LIMIT";
